<template>
  <div>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCard style="margin-top: 20px" v-else>
      <CCardBody v-if="table1">
        <!-- <div id="chart">
          <Apexchart
            type="area"
            height="350"
            :options="chartOptions"
            :series="series"
          ></Apexchart>
        </div> -->
        <!-- <h5>table1</h5> -->
        <!-- <CSelect
        horizontal
        :options="options"
        placeholder="Please select"
        v-model="fielterdata"
        @change="onChange($event)"
        style="width: 300px; float: right; margin-left: 50px; margin-top: 6px"
      /> -->
        <DatePicker
          v-model="value1"
          type="date"
          range
          placeholder="Select date range"
        ></DatePicker>

        <div style="float: right">
          <JsonCSV
            color="primary"
            class="btn btn-default mb-2 clr"
            :data="ragedata"
            name="rage_capture-list.csv"
          >
            Download CSV (This is a slot)
          </JsonCSV>
        </div>
        <CDataTable
          :items="ragedata"
          :fields="fields"
          column-filter
          :items-per-page="10"
          hover
          sorter
          pagination
          @filtered-items-change="setCurrentItems"
        >
          <template #Location="{ item }">
            <td>
              <span v-for="item1 in item.Location" :key="item1">
                {{ item1 }}<br />
              </span>
            </td>
          </template>
          <template #phoneNumber="{ item }">
            <td>
              <span v-if="item.phoneNumber">
                {{ item.phoneNumber }}
              </span>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
      <CCardBody v-if="table2">
        <!-- <h5>table2</h5> -->
        <!-- <CSelect
        horizontal
        :options="options"
        placeholder="Please select"
        v-model="fielterdata"
        @change="onChange($event)"
        style="width: 300px; float: right; margin-left: 50px; margin-top: 6px"
      /> -->

        <DatePicker
          v-model="value1"
          type="date"
          range
          placeholder="Select date range"
        ></DatePicker>
        <div>
          <CButton
            block
            color="success"
            style="width: 200px; margin: auto; margin-top: -33px"
            @click="reloadfunc()"
            >Click to all data</CButton
          >
        </div>
        <div style="float: right">
          <JsonCSV
            color="primary"
            class="btn btn-default mb-2 clr"
            :data="ragedata2"
            name="rage_capture-list.csv"
          >
            Download CSV (This is a slot)
          </JsonCSV>
        </div>
        <CDataTable
          :items="ragedata2"
          :fields="fields"
          column-filter
          :items-per-page="10"
          hover
          sorter
          pagination
          @filtered-items-change="setCurrentItems"
        >
          <template #Location="{ item }">
            <td>
              <span v-for="item1 in item.Location" :key="item1">
                {{ item1 }}<br />
              </span>
            </td>
          </template>
          <template #phoneNumber="{ item }">
            <td>
              <span v-if="item.phoneNumber">
                {{ item.phoneNumber }}
              </span>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import usersData from "../users/UsersData";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import moment from "moment";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Apexchart from "vue-apexcharts";
const db = firebase.firestore();

export default {
  components: {
    JsonCSV,
    DatePicker,
    Apexchart,
  },
  name: "DownloadTable",
  data() {
    return {
      Spinner: true,
      grapdata: "Rage",
      table1: true,
      table2: false,
      filetext: false,
      itemEmail: "",
      myModal: false,
      usersData,
      currentItems: [],
      grapdata: "",
      stakeLimit: 0,
      fielterdata: "",
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      ragedata: [],
      ragedata1: [],
      ragedata2: [],
      options: [],
      value1: [],
      fields: [
        {
          label: "Email",
          key: "id",
          sortable: true,
        },
        {
          label: "Date",
          key: "date",
          sortable: true,
        },

        {
          key: "Regecount",
          key: "Regecount",
          sortable: true,
        },
        {
          key: "Maticcount",
          key: "Maticcount",
          sortable: true,
        },
        {
          key: "Razorcount",
          key: "Razorcount",
          sortable: true,
        },

        {
          key: "Drakoincount",
          key: "Drakoincount",
          sortable: true,
        },
        {
          key: "CryptoPuzzles",
          key: "CryptoPuzzles",
          sortable: true,
        },

        {
          key: "Country",
          key: "Country",
          sortable: true,
        },
        {
          label: "Mobile no",
          key: "phoneNumber",
          sortable: true,
        },
      ],
      details: [],
      collapseDuration: 0,
      conditionLimit: 0,

      data: {
        series: [
          {
            name: "series1",
            data: [31, 40, 28, 51, 42, 109, 100],
          },
          {
            name: "series2",
            data: [11, 32, 45, 32, 34, 52, 41],
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "area",
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          xaxis: {
            type: "datetime",
            categories: [
              "2018-09-19T00:00:00.000Z",
              "2018-09-19T01:30:00.000Z",
              "2018-09-19T02:30:00.000Z",
              "2018-09-19T03:30:00.000Z",
              "2018-09-19T04:30:00.000Z",
              "2018-09-19T05:30:00.000Z",
              "2018-09-19T06:30:00.000Z",
            ],
          },
          tooltip: {
            x: {
              format: "dd/MM/yy HH:mm",
            },
          },
        },
      },
    };
  },
  computed: {
    csvContent() {
      return this.currentItems
        .map((item) => Object.values(item).join(","))
        .join("\n");
    },
    csvCode() {
      return (
        "data:text/csv;charset=utf-8,SEP=,%0A" +
        encodeURIComponent(this.csvContent)
      );
    },
  },
  watch: {
    value1() {
      // let v1 = moment(this.value1[0]).format("DD-MMM-YYYY");
      // let v2 = moment(this.value1[1]).format("DD-MMM-YYYY");
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      console.log("v1", v1);
      console.log("v2", v2);

      db.collection("dateWiseRecord")

        .get()
        .then((snapshot) => {
          console.log("Size snapshot", snapshot.size);
          this.ragedata2 = [];
          // console.log("enter 1")
          snapshot.forEach((doc) => {
            // console.log("enter 2")
            for (let i in doc.data()) {
              let backenddate = moment(
                doc.data()[i].Date.seconds * 1000
              ).format("DD-MMM-YYYY");
              if (
                doc.data()[i].Date.seconds >= v1.seconds &&
                doc.data()[i].Date.seconds <= v2.seconds
              ) {
                let emaildata = this.ragedata1.filter((a) => {
                  return a.email == doc.id;
                });
                // console.log("backenddate",backenddate)
                // console.log("this.ragedata2", doc.data()[i])
                this.ragedata2.push({
                  id: doc.id,
                  firstname:
                    emaildata[0] != undefined ? emaildata[0].firstName : 0,
                  date: backenddate,
                  Regecount:
                    doc.data()[i].Rage != undefined
                      ? doc.data()[i].Rage.count
                      : 0,
                  Maticcount:
                    doc.data()[i].Matic != undefined
                      ? doc.data()[i].Matic.count
                      : 0,
                  Razorcount:
                    doc.data()[i].Razor != undefined
                      ? doc.data()[i].Razor.count
                      : 0,
                  Drakoincount:
                    doc.data()[i].Drakoin != undefined
                      ? doc.data()[i].Drakoin.count
                      : 0,
                  CryptoPuzzles:
                    doc.data()[i]["Crypto Puzzles"] != undefined
                      ? doc.data()[i]["Crypto Puzzles"].count
                      : 0,
                  // AxiInfinite:doc.data()[i]["Axi Infinite"] != undefined ? doc.data()[i]["Axi Infinite"].count:0,
                  Ethaddress:
                    emaildata[0] != undefined ? emaildata[0].ethAddress : 0,
                  Country: emaildata[0] != undefined ? emaildata[0].country : 0,
                  phoneNumber:
                    emaildata[0] != undefined ? emaildata[0].phoneNumber : 0,
                });
                // console.log("this.ragedata2",this.ragedata2.length)
                this.table1 = false;
                this.table2 = true;
              }
            }
          });
        });
    },
  },
  methods: {
    reloadfunc() {
      window.location.reload();
    },
    formatDate(value) {
      // console.log("entered", value);
      return moment(value.seconds * 1000).format("DD-MMM-YYYY");
    },
    updatetokenlimit() {
      if (this.stakeLimit.length > 0) {
        db.collection("users")
          .where("email", "==", this.itemEmail)
          .get()
          .then((snapShot) => {
            snapShot.forEach((doc) => {
              if (!doc.length > 0) {
                // console.log("docs[0]",doc.data())
                let stakeLimit = doc.data().stakeLimit;
                if (stakeLimit) {
                  let lable = this.grapdata;
                  let value = this.stakeLimit;
                  let data = stakeLimit;
                  data[lable] = parseInt(value);
                  // console.log("data[lable]",data[lable])
                  db.collection("users")
                    .doc(doc.id)
                    .update({ stakeLimit: data });
                  Swal.fire(
                    "success",
                    this.itemEmail + " User limit updated successfully",
                    "success"
                  );
                  this.myModal = false;
                } else {
                  let lable = this.grapdata;
                  let value = this.stakeLimit;
                  let data = {
                    stakeLimit: {},
                  };
                  data["stakeLimit"][lable] = parseInt(value);
                  db.collection("users").doc(doc.id).update(data);
                }
              }
            });
          });
      } else {
        // console.log("enter input")
        this.filetext = true;
      }
    },
    editToken(item, index) {
      this.itemEmail = item.id;
      if (this.conditionLimit <= item.TRAGE) {
        this.myModal = true;

        // Swal.fire("success", "Your have to access)", "success");
      } else {
        Swal.fire("Cancelled", "Coin collection limt is low", "error");
      }
      console.log("edit token item", item.id);
      // console.log("Edit token index",index);
      // this.$router.push({ name: "editUser", params: { id: item.id } });
    },
    setCurrentItems(val) {
      this.currentItems = val;
    },
    toggleDetails(item) {
      this.$set(this.tableData[item.id], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
    wizard() {
      this.$router.push({ name: "wizard" });
    },
    assignragedata(doc) {
      let emaildata = this.ragedata.filter((a) => {
        return a.doc.id;
      });
      console.log("data", emaildata);
      let smallDocument = {
        id: doc.id,
        name: doc.data().Rage,
      };
      return smallDocument;
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        symbol: doc.data().symbol,
        totalSupply: doc.data().totalSupply,
        companyName: doc.data().companyName,
        description: doc.data().description,
        country: doc.data().country,
        ethereum: doc.data().ethAddress,
        contract: doc.data().conAddress,
        location: doc.data().location,
        logo: doc.data().logo,
        coinLimit: doc.data().coinLimit,
      };
      return smallDocument;
    },
    assignscaptureData(doc) {
      let emaildata = this.tableData4.filter((a) => {
        return a.email == doc.id;
      });
      // console.log("emaildata", emaildata[0].ethAddress);
      let smallDocument = {
        id: doc.id,
        TRAGE: doc.data()[this.grapdata].length,
        userEmail: emaildata[0].ethAddress,
      };
      return smallDocument;
    },
    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("companyDetails2")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));

            let value = this.tableData.map((n) => {
              return n.name;
            });

            this.options = value;
          });
          this.loading = false;
        });
    },

    onChange(event) {
      // onChange() {
      this.tableData2 = [];
      this.grapdata = event.target.value;
      // this.grapdata = "TRAGE Token";
      console.log("grapdata", this.grapdata);

      const db = firebase.firestore();
      db
        .collection("companyDetails2")
        .where("name", "==", this.grapdata)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("this.tableData2", this.assignsmallData(doc).coinLimit);
            this.conditionLimit = this.assignsmallData(doc).coinLimit;
            console.log("this.conditionLimit", this.conditionLimit);
          });
        }),
        db
          .collection("users")
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              this.ragedata1.push(doc.data());
            });
            console.log("userdata", this.ragedata1);
            db.collection("dateWiseRecord")
              .where(this.grapdata, "!=", null)
              .get()
              .then((snapshot) => {
                snapshot.forEach((doc) => {
                  console.log("income data", doc.data());
                  if (doc.data()[this.grapdata].length == 0) {
                    this.tableData3.push(this.assignscaptureData(doc));
                    this.tableData2 = [];
                  } else {
                    this.tableData2.push(this.assignscaptureData(doc));

                    console.log("this.tableData2", this.tableData2);
                  }

                  // this.tableData2.TRAGE = doc.data()['TRAGE Token'].length;
                });
                this.currentItems = this.tableData2.slice();
                this.loading = false;
              });
          });
    },
    captureToken() {
      db.collection("users")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.ragedata1.push(doc.data());
          });
        });
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      var todayS = dd + "" + mm + "" + yyyy;

      console.log("today", todayS);

      db.collection("dateWiseRecord")
        .where(todayS, "!=", null)
        // .limit(100)
        .get()
        .then((snapshot) => {
          console.log(snapshot.docs.length);
          snapshot.forEach((doc) => {
            let emaildata = this.ragedata1.filter((a) => {
              return a.email == doc.id;
            });
            for (let i in doc.data()) {
              let backenddate = moment(
                doc.data()[i].Date.seconds * 1000
              ).format("DD-MMM-YYYY");
              // if (doc.data()[i].Matic != null) {
              this.Spinner = false;
              this.ragedata.push({
                id: doc.id,
                firstname:
                  emaildata[0] != undefined ? emaildata[0].firstName : 0,
                date: backenddate,
                Regecount:
                  doc.data()[i].Rage != undefined
                    ? doc.data()[i].Rage.count
                    : 0,
                Maticcount:
                  doc.data()[i].Matic != undefined
                    ? doc.data()[i].Matic.count
                    : 0,
                Razorcount:
                  doc.data()[i].Razor != undefined
                    ? doc.data()[i].Razor.count
                    : 0,
                Drakoincount:
                  doc.data()[i].Drakoin != undefined
                    ? doc.data()[i].Drakoin.count
                    : 0,
                CryptoPuzzles:
                  doc.data()[i]["Crypto Puzzles"] != undefined
                    ? doc.data()[i]["Crypto Puzzles"].count
                    : 0,
                //  AxiInfinite:doc.data()[i]["Axi Infinite"] != undefined ? doc.data()[i]["Axi Infinite"].count:0,
                Ethaddress:
                  emaildata[0] != undefined ? emaildata[0].ethAddress : 0,
                Country: emaildata[0] != undefined ? emaildata[0].country : 0,
                phoneNumber:
                  emaildata[0] != undefined ? emaildata[0].phoneNumber : 0,
              });
              // }
            }
          });
        });
    },
    rowClicked(item, index, column, e) {
      // console.log("edit item", item.id);
      this.documentId = item.id;
    },

    deleteRoute(item) {
      // console.log("deleteRoute", item.id);
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("companyDetails")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.gettokens();

    this.captureToken();
  },
};
</script>
<style >
.clr {
  color: #fff !important;
  background-color: #321fdb !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>